import * as React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const PlusSvgComponent = ({ fill = '#44338A' }: { fill?: string }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.66671 2.11099V14.5554M1.44449 8.33322H13.8889"
                    stroke={fill}
                    stroke-width="2.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9998 2.66666V21.3333M2.6665 12H21.3332"
                    stroke={fill}
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6 1.333v9.333M1.917 6h8.166"
                stroke={fill}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default PlusSvgComponent;
